<header>
<div class="mobile-nav p-3">
  <div class="row mobile d-xl-none px-4">
    <div class="col d-flex justify-content-start align-items-center">
      <a href="/">
        <img
          src="../../../assets/img/logo-small-screen.png"
          class="mobile-logo"
          alt="logo"
         
          routerLink="/"
      /></a>
    </div>
    <div class="col d-flex d-lg-none justify-content-end align-items-center">
      <div style="margin-top: 14px">
        <div (click)="toggleIcon = !toggleIcon">
          <img
            src="../../../assets/img/burger-menu.svg"
            class="burger-menu"
            alt="menu"
           
            *ngIf="toggleIcon"
            (click)="expanded = !expanded"
          />
          <img
            src="../../../assets/img/close-menu.png"
            class="close-menu mt-2"
            alt="close"
           
            *ngIf="!toggleIcon"
            (click)="expanded = !expanded"
          />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="side">
    <nav
      class="sidebar mt-3 nav-item blue-50 d-flex flex-column"
      aria-label="Navigazione mobile"
      *ngIf="expanded"
      @slidein
    >
      <a href="/home">
        <span
          class="menu-item pointer"
          routerLink="/home"
          [ngClass]="{ active: isActive('/home') || isActive('/') }"
          >Home</span
        >
      </a>
      <a href="/chi-siamo">
        <span
          class="menu-item pointer"
          routerLink="/chi-siamo"
          [ngClass]="{ active: isActive('/chi-siamo') }"
          >Chi Siamo</span
        >
      </a>

      <a>
        <span
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
          class="menu-item pointer"
          (click)="toggleCorsi()"
          >Corsi
          <img *ngIf="!corsiOpen" src="../../../assets/img/ChevronRight.svg" alt="" aria-hidden="true" />
          <img
            *ngIf="corsiOpen"
            src="../../../assets/img/ChevronDown.svg"
            width="40px"
            alt=""
            aria-hidden="true"
        /></span>
      </a>

      <ng-container *ngIf="corsiOpen">
        <a href="/corsi-coding">
          <span
            class="menu-item pointer"
            href="/corsi-coding"
            [ngClass]="{ active: isActive('/corsi-coding') }"
            >I nostri corsi
          </span>
        </a>
        <a href="/coding-a-scuola">
          <span
            class="menu-item pointer"
            routerLink="/coding-a-scuola"
            [ngClass]="{ active: isActive('/coding-a-scuola') }"
            >Coding a scuola</span
          >
        </a>
      </ng-container>

      <a href="/piattaforma-di-apprendimento">
        <span
          class="menu-item pointer"
          routerLink="/piattaforma-di-apprendimento"
          [ngClass]="{ active: isActive('/piattaforma-di-apprendimento') }"
          >piattaforma</span
        >
      </a>

      <a href="/contatti">
        <span
          class="menu-item pointer"
          routerLink="/contatti"
          [ngClass]="{ active: isActive('/contatti') }"
          >Contatti</span
        >
      </a>

      <div>
        <button class="btn-lightblue" (click)="redirectToApp()">
          <span class="button-txt">Prova Easycode</span>
        </button>
      </div>

      <!-- <p (click)="navigate('home')">Home</p>
      <p (click)="navigate('about')">About</p>
      <p (click)="navigate('models')">Models</p> -->
      <!-- <p (click)="navigate('download')">Download</p> -->
      <!-- <p (click)="navigate('contacts')">Help Center</p> -->
    </nav>
  </div>
</div>

<div class="row m-0 header pt-1 desktop-nav">
  <div class="col-1 d-flex align-items-center">
    <img
      class="ec-logo pointer d-none d-xl-inline-block"
      alt="logo"
     
      src="../../../assets/img/icons/logo_new.svg"
      routerLink="/home"
      role="link"
    />
  </div>
  <nav
    class="col-9 text-center nav-item m-auto blue-50 d-none d-xl-flex"
    style="justify-content: center"
    aria-label="Navigazione principale"
  >
    <span
      class="menu-item pointer"
      routerLink="/home"
      role="link"
      [ngClass]="{ active: isActive('/home') || isActive('/') }"
      >Home</span
    >
    <span
      class="menu-item pointer"
      routerLink="/chi-siamo"
      role="link"
      [ngClass]="{ active: isActive('/chi-siamo') }"
      >Chi siamo</span
    >
    <span
      class="menu-item pointer"
      role="button"
      [ngClass]="{
        active: isActive('/corsi-coding') || isActive('/coding-a-scuola')
      }"
      [matMenuTriggerFor]="appMenu"
      (menuOpened)="menuOpen = true"
      (menuClosed)="menuOpen = false"
      >Corsi
      <img
        src="../../../assets/img/ChevronDown.svg"
        [ngClass]="{ 'rotate-icon': menuOpen }"
        alt=""
        aria-hidden="true"
      />
    </span>

    <span
      class="menu-item pointer"
      routerLink="/piattaforma-di-apprendimento"
      role="link"
      [ngClass]="{ active: isActive('/piattaforma-di-apprendimento') }"
      >Piattaforma</span
    >

    <!--
    <span
      class="menu-item pointer"
      routerLink="/didattica-digitale-per-scuole"
      [ngClass]="{ active: isActive('/didattica-digitale-per-scuole') }"
      >Progetto</span
    >
  -->

    <!-- <div ngbDropdown class="d-inline-block" #myDrop="ngbDropdown">
      <span
        ngbDropdownToggle
        class="menu-item pointer"
        routerLink="/corsi"
        (click)="myDrop.close()"
        >I corsi</span
      >

      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button
          ngbDropdownItem
          class="blue-50 p-3 menu-corsi drop-items"
          *ngFor="let corso of listaCorsi"
          (click)="openCourse(corso)"
        >
          {{ corso.title }}
        </button>
      </div>
    </div> -->

    <span
      class="menu-item pointer"
      routerLink="/contatti"
      role="link"
      [ngClass]="{ active: isActive('/contatti') }"
      >Contatti</span
    >
  </nav>
  <div class="col-2 m-auto d-none d-lg-block" style="justify-content: end; display: flex">
    <button class="btn-lightblue" (click)="redirectToApp()" style="min-width: 210px;">
      <span class="button-txt">Prova Easycode</span>
    </button>
  </div>
</div>

<mat-menu #appMenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item routerLink="/corsi-coding">I nostri corsi</button>
    <button mat-menu-item routerLink="/coding-a-scuola">Coding a scuola</button>
  </ng-template>
</mat-menu>
</header>
